import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { StorageService } from '../_services/storage.service';
import * as jose from 'jose'
import { CustomAuthService } from '../_services/custom-auth.service';
import { environment } from '../../environments/environment';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: any = {
    username: null,
    password: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  constructor(private authService: AuthService, private storageService: StorageService, private customAuthService: CustomAuthService) {
    this.customAuthService.configure({
      Auth: {
        Cognito: {
          allowGuestAccess: true,
          identityPoolId: environment.IDENTITY_POOL_ID,
          userPoolClientId: environment.USER_POOL_CLIENT_ID,
          userPoolId: environment.USER_POOL_ID,
        },
      },
    })
  }

  async ngOnInit(): Promise<void> {
    this.customAuthService.signOut();
    if (this.storageService.isLoggedIn()) {
      this.isLoggedIn = true;
      this.roles = this.storageService.getUser().roles;
    }
  }

  async onSubmit(): Promise<void> {
    const { username, password } = this.form;

    try {
      const isLogged = await this.customAuthService.signIn(username, password);
      this.isLoggedIn = !!isLogged;

      const idToken = jwtDecode(String(this.customAuthService.getIdToken()))

      const customInfo = {
        name: this.getKeyValue(idToken, 'name'),
        email: this.getKeyValue(idToken, 'email'),
        version: 1, // Required, if omited things can break unexpectedly
        parameters: {
          grant_type: this.getKeyValue(idToken, 'custom:grant_type'),
          client_id: this.getKeyValue(idToken, 'custom:client_id'),
          client_secret: this.getKeyValue(idToken, 'custom:client_secret'),
        }
       
      };
      const url = new URL(process.env["HUB_URL"] || "");
      const alg = "HS256";
      const secret = new TextEncoder().encode(process.env["JWT_SECRET"] || "");
      const token = new jose.SignJWT(customInfo)
        .setProtectedHeader({ alg })
        .sign(secret);

      token.then(
        (auth_token) => {
          this.isLoggedIn = true;
          url.searchParams.set('auth_token', auth_token);
          window.location.href = url.toString();
        }
      )

    } catch (error) {
      this.isLoginFailed = true;
      this.errorMessage = "Usuário ou senha inválido."
    }
  }

  reloadPage(): void {
    window.location.reload();
  }

  getKeyValue(obj: any, key: string) {
    return obj[key];
  }
}
